<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'SNMP Community'" style="height: 410px">
        <!--配置按钮-->
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkAdd()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllCommunity"
                />
                <label for="idSelectAllCommunity"></label>
              </th>
              <th
                v-for="(value, key) in snmpCommunity.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in snmpCommunity.data"
              :key="row.community"
              :class="{ 'true:': true }"
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectCommunity' + index"
                  />
                  <label :for="'idRowSelectCommunity' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.community }}</div>
              </td>
              <td>
                <div>{{ row.type }}</div>
              </td>
              <td>
                <div>{{ row.permit }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'SNMP Community'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="community"
                  >Community</label
                >
                <div
                  class="col-sm-5"
                  :class="{
                    'has-error': checkParameters(
                      'community',
                      snmpCommunityForm.community
                    ),
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    id="community"
                    v-model="snmpCommunityForm.community"
                    placeholder="STRING<1-32>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkParameters(
                        'community',
                        snmpCommunityForm.community
                      )
                        ? 'block'
                        : 'none',
                    }"
                    >{{
                      checkParameters("community", snmpCommunityForm.community)
                    }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="accessType"
                  >Access Type</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="accessType"
                    v-model="snmpCommunityForm.type"
                  >
                    <option label="read only" value="ro"></option>
                    <option label="read write" value="rw"></option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="permit"
                  >Permit</label
                >
                <div class="col-sm-5">
                  <select
                    type="text"
                    class="form-control"
                    id="permit"
                    v-model="snmpCommunityForm.permit"
                  >
                    <option label="permit" value="permit"></option>
                    <option label="deny" value="deny"></option>
                  </select>
                </div>
              </div>
              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>
    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"
import en from "./../lang/en-US.js"
import { nonASCIIchar } from "@/utils/check.js"

export default {
  name: "uniqueSipAgent",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  props: ["ontIndex"],

  data() {
    return {
      snmpCommunity: "",
      isShowAddTable: false,
      isSelectAll: false,
      iBox: {},
      snmpCommunityForm: {
        community: "",
        type: "",
        permit: "",
      },
    }
  },

  created() {
    this.loadSnmpCommunity()
  },

  methods: {
    loadSnmpCommunity() {
      get("snmpCommunity")
        .then((res) => {
          this.snmpCommunity = res.data
        })
        .catch((err) => {
          this.snmpCommunity = en.snmpCommunity
        })
    },

    clkAdd() {
      this.isShowAddTable = true
      this.resetField()
      this.selectNull()
    },

    clkDel() {
      var delData = {
        communityList: [],
      }
      for (let i = 0; i < this.snmpCommunity.data.length; i++) {
        if (this.snmpCommunity.data[i].selected) {
          delData.communityList.push({
            community: this.snmpCommunity.data[i].community,
          })
        }
      }
      if (delData.communityList.length < 1) {
        return
      }

      post("snmpCommunityDelete", delData)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadSnmpCommunity()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var snmpCommunityFormTmp = {
        community: "",
        type: "",
        permit: "",
      }
      this.snmpCommunityForm = snmpCommunityFormTmp
    },

    changeSelectAll() {
      for (let i = 0; i < this.snmpCommunity.data.length; i++) {
        if (this.isSelectAll) {
          this.snmpCommunity.data[i].selected = true
        } else {
          this.snmpCommunity.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.snmpCommunity.data.length; i++) {
        this.snmpCommunity.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var Config = {
        community: this.snmpCommunityForm.community,
        type: this.snmpCommunityForm.type,
        permit: this.snmpCommunityForm.permit,
      }

      if (
        this.snmpCommunityForm.community == "" ||
        this.checkParameters("community", this.snmpCommunityForm.community) ||
        this.snmpCommunityForm.type == "" ||
        this.snmpCommunityForm.permit == ""
      ) {
        this.showAlertBox("warn", "Message", "Invalid parameters")
        return
      }

      post("snmpCommunityConfig", Config)
        .then((res) => {
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadSnmpCommunity()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
    },

    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "community") {
        if (
          nonASCIIchar(value) ||
          value.split(" ").length > 1 ||
          value.length > 32
        ) {
          return "invalid community"
        }
      }
      return null
    },
    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
